






































import { Component, Vue } from 'vue-property-decorator';
import { ImproveImageDTO } from '@/api';
import { getAuthToken, fileReader } from '@/utils';
import { authModule } from '@/store';
import UserMenu from '@/components/UserMenu.vue';
import MainNavbar from '@/components/MainNavbar.vue';
import axios from 'axios';
import Upload from '@/components/common/Upload.vue';

@Component({
  name: 'clients',
  components: {
    UserMenu,
    MainNavbar,
    Upload,
  },
})
export default class Clients extends Vue {
  loading = false;

  result: ImproveImageDTO | null = null;

  get user() {
    return authModule.whoIam;
  }

  logout() {
    authModule
      .logout()
      .then(() => {
        this.$router.push({ name: 'login' });
      })
      .catch((e) => {
        this.$message.error(e);
      });
  }

  async uploadImage(files: File[]) {
    const file = files[0] || null;
    if (file) {
      this.loading = true;
      try {
        const binary = await fileReader(file);
        const { data } = await axios.post<ImproveImageDTO>(`https://rest.styleconcierge.ru/api/service/improveImg/${file.name}`, binary, {
          headers: { 'Content-Type': 'application/octet-stream', Authorization: `Bearer ${getAuthToken()}` },
        });
        this.result = data;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      } finally {
        this.loading = false;
      }
    }
  }
}
